import { oc } from '@orpc/contract';
import { listPolicyVersionsOutputSchema } from '../schemas/policies.schemas.js';
export const listPolicyVersionsContract = oc
    .route({
    method: 'GET',
    path: '/policies/versions',
    tags: ['Policies'],
    summary: 'Every policy version, newest first',
})
    .output(listPolicyVersionsOutputSchema);
//# sourceMappingURL=list-policy-versions.contract.js.map